// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-after[data-v-c43b7f6e] {\n  width: 70px !important;\n}\n.regular-size[data-v-c43b7f6e] {\n  width: 100px !important;\n}\n.large-size[data-v-c43b7f6e] {\n  width: 200px !important;\n}", ""]);
// Exports
module.exports = exports;
